import { useLanguage } from "@/contexts/LanguageContext";
import domeRound from "@/assets/dome-round.webp";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
export const Mission = () => {
  const {
    language
  } = useLanguage();
  const content = {
    sv: {
      title: "Vår vision och vårt uppdrag",
      intro: "På Diamond Domes drivs vi av en enkel idé:",
      mainIdea: "Att skapa platser där människor verkligen kan känna sig närvarande och levande.",
      description: "Vi har valt ut de bästa kupolerna från ledande tillverkare världen över — och kombinerar dem med våra egna, svensktillverkade modeller. Varje kupol är skapad för att vara både",
      beautiful: "vacker",
      and: "och",
      functional: "funktionell",
      yearRound: ", året runt.",
      experience: ["Att kliva in i en kupol är som att kliva ut ur vardagens brus.", "Här får du andas.", "Här får du landa.", "Här kan du vara dig själv."],
      moreThan: "Det är mer än en byggnad.",
      ownWorld: "Det är en egen liten värld — en plats där lugn, kreativitet och livsglädje får utrymme att växa.",
      seeRange: "Se vårt utbud",
      toWebshop: "Till Webshoppen",
      altRound: "Inredning i en Diamond Domes geodetisk kupol med naturligt ljus",
      altInterior: "Insida av en Diamond Domes kupol med panoramavy"
    },
    en: {
      title: "Our Vision and Mission",
      intro: "At Diamond Domes, we are driven by a simple idea:",
      mainIdea: "To create spaces where people can truly feel present and alive.",
      description: "We have selected the best domes from leading manufacturers worldwide — and combine them with our own, Swedish-made models. Each dome is created to be both",
      beautiful: "beautiful",
      and: "and",
      functional: "functional",
      yearRound: ", all year round.",
      experience: ["Stepping into a dome is like stepping out of everyday noise.", "Here you can breathe.", "Here you can land.", "Here you can be yourself."],
      moreThan: "It's more than a building.",
      ownWorld: "It's a little world of its own — a place where calm, creativity and joy of life have room to grow.",
      seeRange: "See our range",
      toWebshop: "To the Webshop",
      altRound: "Interior of a Diamond Domes geodesic dome with natural light",
      altInterior: "Inside of a Diamond Domes dome with panoramic view"
    },
    de: {
      title: "Unsere Vision und Mission",
      intro: "Bei Diamond Domes werden wir von einer einfachen Idee angetrieben:",
      mainIdea: "Räume zu schaffen, in denen Menschen sich wirklich präsent und lebendig fühlen können.",
      description: "Wir haben die besten Kuppeln von führenden Herstellern weltweit ausgewählt — und kombinieren sie mit unseren eigenen, in Schweden hergestellten Modellen. Jede Kuppel ist so gestaltet, dass sie sowohl",
      beautiful: "schön",
      and: "als auch",
      functional: "funktional",
      yearRound: " ist, das ganze Jahr über.",
      experience: ["In eine Kuppel zu treten ist wie aus dem Alltagslärm herauszutreten.", "Hier kannst du atmen.", "Hier kannst du landen.", "Hier kannst du du selbst sein."],
      moreThan: "Es ist mehr als ein Gebäude.",
      ownWorld: "Es ist eine eigene kleine Welt — ein Ort, an dem Ruhe, Kreativität und Lebensfreude Raum zum Wachsen haben.",
      seeRange: "Unser Sortiment ansehen",
      toWebshop: "Zum Webshop",
      altRound: "Innenraum einer geodätischen Kuppel von Diamond Domes mit natürlichem Licht",
      altInterior: "Innenansicht einer Diamond Domes Kuppel mit Panoramablick"
    }
  }[language];
  return <section id="mission" className="py-24 px-4 md:px-6 gradient-soft">
      <div className="container mx-auto max-w-6xl">
        <div className="animate-slide-up">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12 text-foreground">
            {content.title}
          </h2>
          
          <div className="space-y-6 text-center text-lg md:text-xl leading-relaxed max-w-4xl mx-auto">
            <p className="text-muted-foreground">
              {content.intro}
            </p>
            
            <p className="text-foreground font-semibold text-2xl">
              {content.mainIdea}
            </p>
            
            <p className="text-muted-foreground">
              {content.description}{" "}
              <span className="font-semibold text-foreground">{content.beautiful}</span> {content.and}{" "}
              <span className="font-semibold text-foreground">{content.functional}</span>{content.yearRound}
            </p>
            
            <div className="grid md:grid-cols-[1fr_2fr_1fr] gap-8 pt-12 pb-8 items-center">
              <div className="flex justify-center">
                <div className="relative w-48 h-48 rounded-full overflow-hidden shadow-elegant bg-background p-2">
                  <img src={domeRound} alt={content.altRound} width={192} height={192} className="w-full h-full object-cover rounded-full" loading="lazy" decoding="async" />
                </div>
              </div>
              
              <div className="space-y-4 italic text-xl text-center">
                {content.experience.map((text, index) => <p key={index}>{text}</p>)}
              </div>
              
              <div className="flex justify-center">
                <img alt={content.altInterior} width={192} height={192} className="w-48 h-48 object-cover rounded-lg shadow-elegant" loading="lazy" decoding="async" src="/lovable-uploads/geo_insida_web_mini.webp" />
              </div>
            </div>
            
            <div className="space-y-4 pt-8">
              <p className="text-muted-foreground">
                {content.moreThan}
              </p>
              
              <p className="text-foreground font-semibold text-2xl">
                {content.ownWorld}
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
              <Button asChild size="lg">
                <Link to="/catalog">{content.seeRange}</Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/shop">
                  {content.toWebshop}
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};